/* eslint-disable @typescript-eslint/no-explicit-any */
import { Spin } from "antd";
import { ComponentType, LazyExoticComponent, ReactElement, Suspense } from "react";
import styled from "styled-components";

const CenteredSpin = styled(Spin)`
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
`;

interface BaseSuspendedComponentProps<P extends Record<string, any>> {
  component: LazyExoticComponent<ComponentType<P>> | ComponentType<P>;
  noFallback?: boolean;
}

export type SuspendedComponentProps<P extends Record<string, any>> = BaseSuspendedComponentProps<P> & P;

export default function Suspended<P extends Record<string, any>>({ component: Component, noFallback, ...props }: SuspendedComponentProps<P>): ReactElement {
  return (
    <Suspense fallback={noFallback ? null : <CenteredSpin />}>
      <Component {...props as any} />
    </Suspense>
  );
}
